import React from 'react';
import { useParams } from 'react-router-dom';
import Course from './course/course';
import NewCourse from './new-course/index';
const MainCourse: React.FunctionComponent<any> = (props) => {
  const param = useParams();
  const p_course = param.course;
  return ['education', 'general-staff'].includes(p_course as string) ? (
    <NewCourse />
  ) : (
    <Course />
  );
};

export default MainCourse;
